import { Box } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { ampli } from 'lib-shared-tracking';
import { useCallback } from 'react';
import { useMount } from 'react-use';

import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { CopilotTrialStatus, useCopilotTrial } from 'utils/useCopilotTrial';

import { PageNavItem } from './pageNavItem';

type CopilotTrialButtonProps = {
  onToggleNavigation?: () => void;
};

export const CopilotTrialButton = ({
  onToggleNavigation,
}: CopilotTrialButtonProps): JSX.Element | null => {
  const {
    status,
    eligibleForTrial,
    visitedTrialPage,
    dismissedLeftMenuCTA,
    dismissedIntroModal,
    dismissedOutroModal,
    setDismissedLeftMenuCTA,
  } = useCopilotTrial();
  const hasManageCopilotAccess = useHasAccess('settings.copilot');

  const dispatch = useAppDispatch();

  useMount(() => {
    if (eligibleForTrial && !dismissedIntroModal) {
      dispatch(
        appActions.showModal({
          modal: {
            type: 'app:copilotTrialIntro',
            arg: {},
          },
        }),
      );
    }

    if (
      hasManageCopilotAccess &&
      eligibleForTrial &&
      status === CopilotTrialStatus.TrialExpired &&
      !dismissedOutroModal
    ) {
      dispatch(
        appActions.showModal({
          modal: {
            type: 'app:copilotTrialOutro',
            arg: {},
          },
        }),
      );
    }
  });

  const onNavigate = useCallback(() => {
    onToggleNavigation?.();
    ampli.agentCopilotTrialLeftmenuCtaClicked();
  }, [onToggleNavigation]);

  const onDismiss = useCallback(() => {
    setDismissedLeftMenuCTA();
    ampli.agentCopilotTrialLeftmenuCtaDismissed();
  }, [setDismissedLeftMenuCTA]);

  if (!eligibleForTrial || dismissedLeftMenuCTA) {
    return null;
  }

  return (
    <Box margin="0 0 250">
      <PageNavItem
        to="/settings/copilot-trial"
        title="New: AI agent co-pilot"
        icon="ai"
        highlight
        onClick={onNavigate}
        notificationBadge={!visitedTrialPage}
        onDismiss={visitedTrialPage ? onDismiss : undefined}
      />
    </Box>
  );
};
